import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnDecimalFormatting } from "@/lib/globalFormatterHelper";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { isNotationToDecimalValueType } from "@/lib/interfaces and Enums/TYPENotations";
import tradeDataStore from "@/store/tradeDataStore";
import { returnCouponValueToRender } from "./couponActionSummarySwapHelpers";

// Pure formatting function - returns value only (for copy/paste)
export function formatCouponValue(
  params: any,
  thisTrade?: ExecutionStrategy,
): string {
  if (!thisTrade) {
    return "";
  }

  const valuesObject = returnCouponValueToRender(params, thisTrade);
  const valueToRender = Number(valuesObject?.value);
  const notationToRender = valuesObject?.notation;

  if (!valueToRender || !notationToRender) {
    return "";
  }

  if (!isNotationToDecimalValueType(notationToRender)) {
    // If the string returned as notation will not work with the multiply function, return early.
    return "";
  }

  const formattedValueToReturn = returnDecimalFormatting(
    valueToRender,
    notationToRender,
  );

  return `${formattedValueToReturn} `;
}

// Format with notation for display
export function formatCouponWithNotation(
  params: any,
  thisTrade?: ExecutionStrategy,
): string {
  if (!thisTrade) {
    return "";
  }

  const valuesObject = returnCouponValueToRender(params, thisTrade);
  const valueToRender = Number(valuesObject?.value);
  const notationToRender = valuesObject?.notation;

  if (!valueToRender || !notationToRender) {
    return "";
  }

  if (!isNotationToDecimalValueType(notationToRender)) {
    return "";
  }

  const formattedValueToReturn = returnDecimalFormatting(
    valueToRender,
    notationToRender,
  );

  return `${formattedValueToReturn}${notationToRender}`;
}

// AG Grid valueFormatter for copy/paste (value only, no notation)
export function couponCellValueFormatter(params: any): string {
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const currentTradeData = tradeDataStore.getState().tradeData;
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid === fullTradeData.esid,
  );

  return formatCouponValue(params, thisTrade);
}
